module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    class: [_vm.$root.isRTL ? 'fullContentRTL' : 'fullContent']
  }, [_c('v-toolbar', {
    staticClass: "fullToolbar",
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('v-toolbar-title', {
    staticClass: "white--text",
    staticStyle: {
      "font-size": "30px",
      "text-align": "right"
    }
  }, [_c('i', {
    staticClass: "material-icons icon"
  }, [_vm._v("settings")]), _vm._v("\n      " + _vm._s(_vm.$t('settings')) + "\n    ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-tabs', {
    staticStyle: {
      "padding": "20px",
      "padding-bottom": "5px"
    },
    attrs: {
      "input": "tabChanged",
      "dark": "",
      "scrollable": false
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-bar', {
    staticStyle: {
      "background-color": "#fff",
      "border-bottom": "2px solid #F7941D"
    },
    slot: "activators"
  }, [_c('v-tabs-item', {
    attrs: {
      "href": "#tab-0"
    }
  }, [_vm._v("חבילות")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-1"
    }
  }, [_vm._v("שלבי התקדמות")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": "#tab-2"
    }
  }, [_vm._v("הגדרות מערכת")])], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-0"
    }
  }, [_c('TablePackages')], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-1"
    }
  }, [_c('TableStatuses')], 1), _vm._v(" "), _c('v-tabs-content', {
    staticStyle: {
      "background-color": "#fff"
    },
    attrs: {
      "id": "tab-2"
    }
  }, [_c('TableSettings')], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43bce6a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Settings.vue
// module id = 882
// module chunks = 2